function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M25.996 8.91A1 1 0 0025 8h-5V6c0-3.309-2.69-6-6-6-3.309 0-6 2.691-6 6v2H3a1 1 0 00-.996.91l-2 22A.998.998 0 001 32h26a1.005 1.005 0 00.996-1.09l-2-22zM10 6c0-2.206 1.795-4 4-4s4 1.794 4 4v2h-8V6zM2.096 30l1.817-20H8v2.277c-.596.347-1 .985-1 1.723a2 2 0 004 0c0-.738-.404-1.376-1-1.723V10h8v2.277A1.99 1.99 0 0017 14a2 2 0 004 0 1.99 1.99 0 00-1-1.723V10h4.087l1.817 20H2.096z",
  fillRule: "nonzero"
});

function SvgPaperBag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32
  }, props), _ref);
}

export default SvgPaperBag;